<template>
    <v-card flat tile :loading="loading" :disabled="loading" min-height="calc(100% - 60px)">
        <v-card-title class="subtitle-2 text-uppercase black--text pt-6 px-6 d-flex align-center">
          <span>Accounts ({{ accounts.length }})</span>
          <v-spacer></v-spacer>
          <v-btn-toggle color="accent" borderless>
            <v-btn small v-for="(item, index) in toolbarItems"
              :key="index" depressed
              @click="onToolAction(item)"
            >
              <v-icon dark small class="mr-1">{{ item.icon }}</v-icon>
              {{ item.label }}
            </v-btn>
          </v-btn-toggle>
        </v-card-title>
        <v-card-text class="px-6 pb-6">
            <template v-if="accounts.length > 0">
              <v-list two-line dense>
                <v-list-item
                    v-for="(item, index) in accounts"
                    :key="index"
                    @click="onEditAccount(index, item)"
                >
                  <v-list-item-avatar>
                    <v-icon
                        :class="item.title.iconClass"
                        v-text="item.title.icon"
                    ></v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title.value"></v-list-item-title>
                    <v-list-item-subtitle>
                      <div>{{ item.email }}</div>
                      <a class="blue--text" :href="item.uri"
                        target="_blank" v-if="item.uri"
                      >{{ item.uri }}</a>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                      <v-btn icon @click="onEditAccount(index, item)">
                        <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                      </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </template>
            <al-empty-results v-else
                v-show="!loading"
                :options="emptyOptions"
                @action="onAddAccount"
            ></al-empty-results>
        </v-card-text>
        <v-dialog v-model="popups.add.dialog"
            max-width="480px"
            persistent>
            <al-project-accounts-form
                v-if="popups.add.dialog"
                :extra-data="project"
                :form-data="selectedItem"
                :edit-index="selectedIndex"
                @close="onEditCancel"
                @save="onEditSuccess"
            ></al-project-accounts-form>
        </v-dialog>
        <v-dialog v-model="popups.import.dialog"
            max-width="720px"
            persistent>
            <al-import-json-form
                v-if="popups.import.dialog"
                :extra-data="project"
                @close="onImportCancel"
                @save="onImportSuccess"
            ></al-import-json-form>
        </v-dialog>
    </v-card>
</template>

<script>
export default {
  props: ['project', 'loading'],
  data() {
    return {
      emptyOptions: {
        title: 'No account added at the moment',
        btnText: 'Add Account',
        showBtn: true,
      },
      selectedItem: undefined,
      selectedIndex: -1,
      toolbarItems: [{
        icon: 'mdi-account-plus-outline',
        action: 'onAddAccount',
        label: 'Add',
      }, {
        icon: 'mdi-import',
        action: 'onImportAccount',
        label: 'Import',
      }, {
        icon: 'mdi-export',
        action: 'onExportAccount',
        label: 'Export',
      }],
      popups: {
        add: {
          dialog: false,
        },
        import: {
          dialog: false,
        },
      },
    };
  },
  computed: {
    accounts() {
      return this.project && this.project.accounts ? this.project.accounts : [];
    },
  },
  methods: {
    resetEdit() {
      this.popups.add.dialog = false;
      this.selectedItem = undefined;
      this.selectedIndex = -1;
    },
    resetImport() {
      this.popups.import.dialog = false;
    },
    onAddAccount() {
      this.popups.add.dialog = true;
      this.selectedItem = undefined;
    },
    onEditCancel() {
      this.resetEdit();
    },
    onEditSuccess($event) {
      this.resetEdit();
      this.$emit('update', $event);
    },
    onEditAccount(index, item) {
      this.popups.add.dialog = true;
      this.selectedItem = {
        ...item,
      };
      this.selectedIndex = index;
    },
    onImportCancel() {
      this.resetImport();
    },
    onImportSuccess($event) {
      this.resetImport();
      this.$emit('update', $event);
    },
    onImportAccount() {
      this.popups.import.dialog = true;
    },
    onExportAccount() {
      const data = JSON.stringify(this.accounts);
      const blob = new Blob([data], { type: 'text/plain' });
      const e = document.createEvent('MouseEvents');
      const a = document.createElement('a');
      a.download = 'accounts.json';
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    onToolAction(item) {
      this[item.action]();
    },
  },
};
</script>
